import { useMutation } from "@tanstack/react-query";
import { getTransbankMethods, crearPreferenciaMP, verificarPagoMP, reembolsarMP } from "../api";

export const useGetTransbankMethods = () => {
  const query = useMutation({
    mutationKey: ['useGetTransbankMethods'],
    mutationFn: getTransbankMethods,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useCrearPreferenciaMP = () => {
  const query = useMutation({
    mutationKey: ['useCrearPreferenciaMP'],
    mutationFn: crearPreferenciaMP,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useVerificarPagoMP = () => {
  const query = useMutation({
    mutationKey: ['useVerificarPagoMP'],
    // signal se extrae del payload para que no viaje como parte del body del
    // request (AbortController agregado para el timeout de cliente de
    // MercadoPagoReturnPage.jsx).
    mutationFn: ({ signal, ...data }) => verificarPagoMP(data, { signal }),
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};

export const useReembolsarMP = () => {
  const query = useMutation({
    mutationKey: ['useReembolsarMP'],
    mutationFn: reembolsarMP,
    onSuccess: (status) => {
      return status;
    },
  });

  return query;
};
